import { createStore, createEvent } from 'effector';
import { LocalStorageUtils } from '@shared/utils';

const setDarkMode = createEvent<boolean>();
const clearEvent = createEvent();

const $store = createStore<boolean>(LocalStorageUtils.getThemeIsDark())
  .on(setDarkMode, (prev, data) => data)
  .reset(clearEvent);

$store.watch((isDark) => {
  //change theme
  if (isDark) document.documentElement.className = 'dark';
  else document.documentElement.className = '';

  //save on localStorage
  LocalStorageUtils.setThemeIsDark(isDark);
});

export const $themeStore = {
  events: {
    setIsDarkMode: setDarkMode,
    clear: clearEvent,
  },
  store: $store,
};
